import { Link } from 'react-router-dom';
import type { V2Finale } from './content';

export function Finale({ content }: { content: V2Finale }) {
  return (
    <section className="v2-section v2-finale">
      <div className="v2-container">
        <div className="v2-finale-statement">
          <h2 className="v2-finale-title">
            <span data-reveal>{content.titleLine1}</span>
            <em className="v2-serif-accent v2-accent-lime" data-reveal data-reveal-delay="0.1">
              {content.titleLine2}
            </em>
          </h2>
          <p className="v2-body" data-reveal data-reveal-delay="0.18">
            {content.body}
          </p>
        </div>

        <div className="v2-finale-specialties" data-reveal>
          <span className="v2-finale-label">{content.specialtiesLabel}</span>
          <ul>
            {content.specialties.map((specialty) => (
              <li key={specialty}>{specialty}</li>
            ))}
          </ul>
        </div>

        <div className="v2-finale-cta" data-reveal>
          <div>
            <h3>{content.ctaTitle}</h3>
            <p>{content.ctaBody}</p>
          </div>
          <div className="v2-finale-actions">
            <Link to={content.primaryCta.href} className="v2-btn v2-btn-lime">
              {content.primaryCta.label}
              <i className="ph ph-arrow-right" aria-hidden="true" />
            </Link>
            <Link to={content.secondaryCta.href} className="v2-btn v2-btn-ghost-light">
              {content.secondaryCta.label}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
